import React, { Component, Fragment } from 'react';
import '../global';
import { updateFormErrors } from '../actions';
import { connect } from 'react-redux';
import CheckoutCardDetails from './checkout-card-details';
import CheckoutAddressShipping from './checkout-address-shipping';
import CheckoutAddressBilling from './checkout-address-billing';

class CheckoutPart2 extends Component {

	//TODO GET BILLING ADDRESS FROM IMIS
	constructor( props ) {
		super( props );
		this.state = {
			submittingOrder: false
		};
		this.cart_info = getCartInfo();
		this.imis_billing_info = this.cart_info.imis_billing_info;
		this.imisError = this.cart_info.checkout_errors;
		this.handleSubmit = this.handleSubmit.bind( this );
		// this.toggleSubmittingOrder = this.toggleSubmittingOrder.bind(this);
		// this.handleCompleteOrder = this.handleCompleteOrder.bind(this);
	}

	handleSubmit( event ) {
		// event.preventDefault();
		// console.log('Form submitted');
	}

	render() {
		const { cart } = this.props;
		const products = Array.isArray( cart.products ) ? cart.products : [];
		let physical_items = false;
		for ( let i = 0; i < products.length; i++ ) {
			if ( products[ i ].is_physical === true ) {
				physical_items = true;
				break;
			}
		}

		return (<div className="col-md-8 col-lg-9">
				<div class="row no-gutter">
					{/* <?php if ( ! is_user_logged_in() ) : ?> */ }
					{/* <div class="col-sm-8">
					 <h3 class="checkout-title"><?php esc_html_e( 'Please log in to continue.', 'isda_theme' ); ?></h3>
					 <?php echo do_shortcode( '[member-all-login-forms]' ); ?>
					 </div> */ }
					{ this.imisError || this.props.form_errors.general && (<div class="bg-danger error-number">
							{ this.imisError || this.props.form_errors.general }
						</div>
					) }
					<form action="" id="bookstore-checkout" method="post"
					      class=" checkout-form" data-toggle="validator"
					      onSubmit={ this.handleSubmit }>
						<div
							dangerouslySetInnerHTML={ { __html: this.cart_info.nonce } }/>
						<div class="back-to-btn back-to-cart-container">
							<button class="back-to-cart-button"
							        onClick={ this.props.backToCart }>
								<i class="fa fa-arrow-left"
								   aria-hidden="true"></i>
								Back to Cart
							</button>
						</div>


						<h3 class="checkout-title">Billing Address</h3>
						<p id="billing-address-note">
							Your billing address is pulled from your profile's
							Work Address. You can update your address on
							<a href="/my-account"> your account </a>
							or contact Member Services for help.
						</p>
						<CheckoutAddressBilling/>

						{ physical_items ? (<div>
								<h3 class="checkout-title">Shipping Address</h3>
								<CheckoutAddressShipping/>
							</div>
						) : (<Fragment>
								<input type="hidden"
								       name="_checkout_shipping_address"
								       value={ this.imis_billing_info.get_address_1 || '' }/>
								<input type="hidden"
								       name="_checkout_shipping_address_two"
								       value={ this.imis_billing_info.get_address_2 || '' }/>
								<input type="hidden"
								       name="_checkout_shipping_country"
								       value={ this.imis_billing_info.get_address_country || '' }/>
								<input type="hidden"
								       name="_checkout_shipping_city"
								       value={ this.imis_billing_info.get_address_city || '' }/>
								<input type="hidden"
								       name="_checkout_shipping_state"
								       value={ this.imis_billing_info.get_address_state || '' }/>
								<input type="hidden"
								       name="_checkout_shipping_postal_code"
								       value={ this.imis_billing_info.get_address_zip || '' }/>
							</Fragment>
						  ) }

						<h3 class="checkout-title">Payment Information</h3>
						<CheckoutCardDetails/>


					</form>

				</div>
			</div>
		);
	}
}

function mapStateToProps( { cart, form_errors } ) {
	return {
		cart,
		form_errors
	};
}

export default connect( mapStateToProps, { updateFormErrors } )( CheckoutPart2 );